import { Box, Drawer } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import { useNavigate, useParams } from 'react-router-dom'
import AdminList from './List/AdminList';
import { useSelector } from 'react-redux';
import EvaluationDashboard from './EvaluationDashboard';
import EvaluationFormIndex from './Form';

const baseUrl = '/admin-evaluation/evaluation'

export default function EvaluationPage() {
    const navigate = useNavigate()
    const { id } = useParams()
    const { district } = useSelector(state => state.session)

    const isServiceProvider = district?.isServiceProvider === true

    return (
        <Box>
            <BasePathProvider value={`${baseUrl}`}>
                {isServiceProvider ? <AdminList /> : <EvaluationDashboard />}
                <Drawer 
                    PaperProps={{ sx: { width: '800px' } }}
                    anchor="right"
                    open={Boolean(id)}
                    onClose={() => navigate(baseUrl)}
                >
                    <EvaluationFormIndex />
                </Drawer>
            </BasePathProvider>
        </Box>
    )
}
